import { call, cancelled, put, select } from 'redux-saga/effects';
import { api } from 'api';
import { getArticle, getEnv, getIsSetPath, getRegionCode } from 'common/selectors';
import log from 'loglevel';
import { CancelTokenSource } from '@okapi/http';
import { EffectR } from 'types/utils';
import { FETCH_RELATED_PRODUCTS } from './actions';
import { fetchRelatedProducts } from './utils/api';
import { RelatedProducts, RequestProps } from './types';

export function* doFetchRelatedProducts() {
  const productId: string = yield select(getArticle);
  const regionCode: string = yield select(getRegionCode);
  const isSetPath: boolean = yield select(getIsSetPath);

  const abortController: CancelTokenSource = yield call([api, 'abortController']);

  yield put(FETCH_RELATED_PRODUCTS.request());
  const { requestID } = (yield select(getEnv)) as EffectR.Select<typeof getEnv>;
  yield call(log.info, 'Related-products was requested', 'requestID: ', requestID, 'dateNow: ', Date.now());

  const options: RequestProps = { productId, regionCode };

  if (isSetPath) {
    options.relationType = 'variant,set';
  }

  try {
    const data: RelatedProducts = yield call(fetchRelatedProducts, options, {
      cancelToken: abortController.token,
    });

    yield put(FETCH_RELATED_PRODUCTS.success(data));
    yield call(log.info, 'Related-products was loaded', 'requestID: ', requestID, 'dateNow: ', Date.now());
  } catch (e) {
    if (e instanceof Error) {
      yield put(FETCH_RELATED_PRODUCTS.failure(e));
      yield call(
        log.info,
        'Related-products has error',
        'requestID: ',
        requestID,
        'dateNow: ',
        Date.now(),
        'e',
        e,
      );
    }
  } finally {
    if ((yield cancelled()) as boolean) {
      abortController.cancel();
      yield call(
        log.info,
        'Related-products was cancelled',
        'requestID: ',
        requestID,
        'dateNow: ',
        Date.now(),
      );
      yield put(FETCH_RELATED_PRODUCTS.cancel());
    }
  }
}

export function* runFetchRelatedProducts() {
  yield call(doFetchRelatedProducts);
}
